import React, { useEffect, useRef, useState } from "react";

// Iconos de la maqueta (trazos simples).
export const StudioIcon = ({ name, size = 18 }) => {
  const common = { width: size, height: size, viewBox: "0 0 24 24", "aria-hidden": true };
  switch (name) {
    case "board":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
          <path d="M12 3 3 8l9 5 9-5-9-5Z" />
          <path d="M3 13l9 5 9-5" />
          <path d="M3 17.5 12 22l9-4.5" />
        </svg>
      );
    case "cube":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2" strokeLinejoin="round">
          <path d="M12 2 3 7v10l9 5 9-5V7l-9-5Z" />
          <path d="M3 7l9 5 9-5M12 12v10" />
        </svg>
      );
    case "bg":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2">
          <rect x="3" y="4" width="18" height="16" rx="3" />
          <path d="m3 16 5-5 4 4 3-3 6 6" />
          <circle cx="16" cy="9" r="1.6" />
        </svg>
      );
    case "user":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2">
          <circle cx="12" cy="8" r="4" />
          <path d="M4 21c1.5-4 4.5-6 8-6s6.5 2 8 6" />
        </svg>
      );
    case "lock":
      return (
        <svg {...common} fill="currentColor">
          <path d="M7 10V7a5 5 0 0 1 10 0v3h1a1 1 0 0 1 1 1v9a1 1 0 0 1-1 1H6a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h1Zm2 0h6V7a3 3 0 0 0-6 0v3Z" />
        </svg>
      );
    case "trophy":
      return (
        <svg {...common} fill="currentColor">
          <path d="M7 3h10v2h3v3a4 4 0 0 1-4 4h-.3A5 5 0 0 1 13 14.9V18h3v3H8v-3h3v-3.1A5 5 0 0 1 8.3 12H8a4 4 0 0 1-4-4V5h3V3Zm0 4H6v1a2 2 0 0 0 1 1.7V7Zm10 0v2.7A2 2 0 0 0 18 8V7h-1Z" />
        </svg>
      );
    case "gem":
      return (
        <svg {...common} fill="currentColor">
          <path d="M6 3h12l4 6-10 12L2 9l4-6Z" />
        </svg>
      );
    case "check":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="3.5">
          <path d="m5 12 5 5 9-10" />
        </svg>
      );
    case "chev":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2.4">
          <path d="m9 6 6 6-6 6" />
        </svg>
      );
    case "back":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2.4">
          <path d="M15 6l-6 6 6 6" />
        </svg>
      );
    case "rot":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M21 12a9 9 0 1 1-3-6.7L21 8" />
          <path d="M21 3v5h-5" />
        </svg>
      );
    case "expand":
      return (
        <svg {...common} fill="none" stroke="currentColor" strokeWidth="2">
          <path d="M14 4h6v6M10 20H4v-6M20 4l-7 7M4 20l7-7" />
        </svg>
      );
    case "play":
      return (
        <svg {...common} fill="currentColor">
          <path d="M7 4.5v15l13-7.5-13-7.5Z" />
        </svg>
      );
    default:
      return null;
  }
};

const formatPrice = (value) => {
  const raw = String(value ?? "").replace(/[^0-9]/g, "");
  if (!raw) return String(value || "");
  return Number(raw).toLocaleString("es-ES");
};

// Etiquetas iguales en todo Modo Diseñar.
export const StudioBadge = ({ status, price, requirement, className = "" }) => {
  if (status === "on") {
    return (
      <span className={`xima-studio-badge is-on ${className}`}>
        <StudioIcon name="check" size={11} /> EN USO
      </span>
    );
  }
  if (status === "won") {
    return (
      <span className={`xima-studio-badge is-won ${className}`}>
        <StudioIcon name="trophy" size={11} /> GANADO
      </span>
    );
  }
  if (status === "shop") {
    return (
      <span className={`xima-studio-badge is-shop ${className}`}>
        <StudioIcon name="gem" size={11} /> {formatPrice(price)}
      </span>
    );
  }
  if (status === "lock") {
    return (
      <span className={`xima-studio-badge is-lock ${className}`}>
        <StudioIcon name="lock" size={11} /> {requirement || "Bloqueado"}
      </span>
    );
  }
  return <span className={`xima-studio-badge is-free ${className}`}>GRATIS</span>;
};

export const StudioLegend = () => (
  <div className="xima-studio-legend">
    <StudioBadge status="free" /> <span>Gratis</span>
    <StudioBadge status="won" /> <span>Ganado</span>
    <StudioBadge status="shop" price="200" /> <span>Tienda</span>
    <StudioBadge status="lock" requirement="Nivel" /> <span>Bloqueado</span>
  </div>
);

export const StudioChips = ({ options, value, onChange, small = false, dots = false }) => (
  <div className="xima-studio-chips" role="group">
    {options.map((option) => (
      <button
        key={option.id}
        type="button"
        className={`xima-studio-chip${small ? " is-small" : ""}${value === option.id ? " is-on" : ""}`}
        onClick={() => onChange(option.id)}
        aria-pressed={value === option.id}
      >
        {dots && option.id !== "all" ? <i aria-hidden="true" /> : null}
        {option.label}
      </button>
    ))}
  </div>
);

// Carrusel tipo Cover Flow: tarjeta central grande con borde cian, las de los
// lados giradas ~52° y con reflejo. Se desliza con flechas, arrastre o rueda.
export const CoverFlow = ({
  items,
  index,
  onIndexChange,
  onPick,
  cardWidth = 330,
  cardHeight = 228,
  gap = 200,
  sideScale = 0.8,
  maxSide = 4,
  className = "",
  showDots = false,
}) => {
  const dragRef = useRef(null);
  const wheelRef = useRef(0);
  const containerRef = useRef(null);
  const [fit, setFit] = useState(1);
  const baseCardWidth = cardWidth;
  const count = items.length;

  // En pantallas estrechas las tarjetas se encogen para que se vean los lados.
  useEffect(() => {
    const element = containerRef.current;
    if (!element || typeof ResizeObserver === "undefined") return undefined;
    const observer = new ResizeObserver(([entry]) => {
      const width = entry?.contentRect?.width || 0;
      setFit(width ? Math.max(0.45, Math.min(1, width / (baseCardWidth * 2.9))) : 1);
    });
    observer.observe(element);
    return () => observer.disconnect();
  }, [baseCardWidth]);
  cardWidth *= fit;
  cardHeight *= fit;
  gap *= fit;
  const safeIndex = count ? Math.max(0, Math.min(count - 1, index)) : 0;

  useEffect(() => {
    if (count && index !== safeIndex) onIndexChange(safeIndex);
  }, [count, index, safeIndex, onIndexChange]);

  const move = (step) => {
    if (!count) return;
    onIndexChange(Math.max(0, Math.min(count - 1, safeIndex + step)));
  };

  const handlePointerDown = (event) => {
    dragRef.current = { x: event.clientX, moved: false };
  };
  const handlePointerMove = (event) => {
    const drag = dragRef.current;
    if (!drag) return;
    const delta = event.clientX - drag.x;
    if (Math.abs(delta) > cardWidth * 0.35) {
      move(delta < 0 ? 1 : -1);
      drag.x = event.clientX;
      drag.moved = true;
    }
  };
  const handlePointerUp = () => {
    setTimeout(() => {
      dragRef.current = null;
    }, 0);
  };

  useEffect(() => {
    const element = containerRef.current;
    if (!element) return undefined;
    const handleWheel = (event) => {
      // La rueda del ratón (arriba/abajo) también pasa al siguiente o al anterior.
      const delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY;
      if (!delta) return;
      event.preventDefault();
      const now = Date.now();
      if (now - wheelRef.current < 170) return;
      wheelRef.current = now;
      move(delta > 0 ? 1 : -1);
    };
    element.addEventListener("wheel", handleWheel, { passive: false });
    return () => element.removeEventListener("wheel", handleWheel);
  });

  return (
    <div className={`xima-studio-coverflow ${className}`}>
      <div
        ref={containerRef}
        className="xima-studio-coverflow-stage"
        style={{ height: cardHeight + 40 }}
        onPointerDown={handlePointerDown}
        onPointerMove={handlePointerMove}
        onPointerUp={handlePointerUp}
        onPointerLeave={handlePointerUp}
      >
        {items.map((item, itemIndex) => {
          const d = itemIndex - safeIndex;
          const a = Math.abs(d);
          if (a > maxSide) return null;
          const sign = Math.sign(d);
          const width = d === 0 ? cardWidth : cardWidth * sideScale;
          const height = d === 0 ? cardHeight : cardHeight * sideScale;
          const x = d === 0 ? 0 : sign * (cardWidth * 0.52 + (a - 1) * gap + gap * 0.55);
          return (
            <div
              key={item.key}
              className={`xima-studio-card${d === 0 ? " is-center" : ""}${item.className ? ` ${item.className}` : ""}`}
              style={{
                width,
                height,
                marginLeft: -width / 2,
                marginTop: -height / 2,
                transform: `translateX(${x}px) translateZ(${-a * 70}px) rotateY(${-sign * (a ? 52 : 0)}deg)`,
                zIndex: 10 - a,
                filter: a ? `brightness(${1 - a * 0.17})` : "none",
                opacity: a >= 3 ? 0.55 : 1,
                "--card-c1": item.c1 || "#13224a",
                "--card-c2": item.c2 || "#050a18",
              }}
              role="button"
              tabIndex={a <= 1 ? 0 : -1}
              aria-label={item.label}
              onMouseDown={(event) => event.preventDefault()}
              onClick={() => {
                if (dragRef.current?.moved) return;
                if (d !== 0) onIndexChange(itemIndex);
                onPick?.(item, itemIndex);
              }}
              onKeyDown={(event) => {
                if (event.key === "Enter" || event.key === " ") {
                  event.preventDefault();
                  onIndexChange(itemIndex);
                  onPick?.(item, itemIndex);
                }
              }}
            >
              {item.content}
            </div>
          );
        })}
      </div>
      <button
        type="button"
        className="xima-studio-arrow is-left"
        onClick={() => move(-1)}
        disabled={safeIndex <= 0}
        aria-label="Anterior"
      >
        <StudioIcon name="back" />
      </button>
      <button
        type="button"
        className="xima-studio-arrow is-right"
        onClick={() => move(1)}
        disabled={safeIndex >= count - 1}
        aria-label="Siguiente"
      >
        <StudioIcon name="chev" />
      </button>
      {showDots && count > 1 ? (
        <div className="xima-studio-dots" aria-hidden="true">
          {items.map((item, itemIndex) => (
            <i key={item.key} className={itemIndex === safeIndex ? "is-on" : ""} />
          ))}
        </div>
      ) : null}
    </div>
  );
};
